import en from './translations/en'
import fr from './translations/fr'

export default { en, fr }